import propTypes from 'prop-types';
import React from 'react';

import config from "../../config/config"
import TextField from "../../ui/components/form-fields/text-field";
import {QnectValidator} from "./qnect-validator";
import useConfig from "./qnect-config";
import {_getLang} from "../../store/system/service";
import {connect} from "react-redux";

const QnectTextField = React.forwardRef((
    {
        lang,
        field,
        formId,
        label,
        value,
        placeholder,
        errorMessage,
        helperText,
        maxLength,
        onChange,
        onBlur,
        endAdornment,
        disabled,
        ...rest
    },
    ref
) => {

        const cfg = useConfig(lang);

        return (
            <QnectValidator
                formId={formId}
                lang={lang}
                field={field}
                hasOnBlur={onBlur ? true : false}
                onChangeCallback="onChange"
                onBlurCallback="onBlur"
                errorMessage={errorMessage}
                validators={cfg(field, "validators")}
            >
                <TextField
                    label={label || cfg(field, "label")}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    helperText={helperText}
                    placeholder={placeholder}
                    errorMessage={cfg(errorMessage)}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    endAdornment={endAdornment}
                    disabled={disabled}
                    {...rest}
                >
                </TextField>
            </QnectValidator>
        )
});

QnectTextField.propTypes = {
    field: propTypes.string,
    formId: propTypes.string,
    label: propTypes.string,
    value: propTypes.string,
    className: propTypes.string,
    maxLength: propTypes.number,
    helperText: propTypes.string,
    placeholder: propTypes.string,
    errorMessage: propTypes.string,
    onChange: propTypes.func,
    onBlur: propTypes.func,
};

QnectTextField.displayName = 'QnectTextField';

const mapStateToProps = (state) => {
    return {
        lang: _getLang(state)
    }
};

export default connect(mapStateToProps)(QnectTextField);
